import { useState } from "react";
import { Calculator as CalculatorIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calculator } from "./Calculator";

export const FloatingCalculator = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Action Button */}
      <Button
        onClick={() => setIsOpen(true)}
        className={`fixed bottom-16 right-6 h-12 w-12 rounded-full shadow-glow hover:shadow-lg transition-all duration-300 z-20 financial-button ${isOpen ? 'scale-125' : 'hover:scale-110'}`}
        size="icon"
        aria-label="Open calculator"
      >
        <CalculatorIcon className="h-5 w-5" />
      </Button>

      {/* Calculator Side Panel */}
      {isOpen && (
        <>          
          {/* Side Panel */}
          <div className="fixed bottom-28 right-4 w-64 bg-gradient-card border border-primary/20 rounded-xl shadow-glow z-30 transform transition-all duration-300 ease-out backdrop-blur-sm animate-scale-in">
            {/* Header */}
            <div className="flex items-center justify-between p-3 border-b border-primary/20 bg-gradient-primary rounded-t-xl">
              <div className="flex items-center gap-2">
                <CalculatorIcon className="h-4 w-4 text-primary-foreground" />
                <h3 className="text-sm font-semibold text-primary-foreground">Calculator</h3>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setIsOpen(false)}
                className="h-6 w-6 text-primary-foreground hover:bg-primary-foreground/20"
                aria-label="Close calculator"
              >
                <X className="h-3 w-3" />
              </Button>
            </div>
            
            {/* Calculator Content */}
            <div className="p-3 max-h-96 overflow-y-auto">
              <Calculator />
            </div>
          </div>
        </>
      )}
    </>
  );
};